import type { IVariable } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { RulePreview } from '../RulePreview';
import { VariableIcon } from './VariableIcon';

export interface VariablePreviewProps {
  variable: IVariable;
}

export const VariablePreview = ({ variable }: VariablePreviewProps) => {
  return (
    <RulePreview>
      <VariableIcon type={variable.type} />
      <RulePreview.Tooltip title={variable.name}>
        <div className="truncate max-w-[200px]">
          <TextBase
            label={variable.name}
            color="text-ds-natural-600"
          />
        </div>
      </RulePreview.Tooltip>
    </RulePreview>
  );
};
